import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'; // Angular 7 için pipe operatörü
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Eğer API'den 401 Unauthorized (Yetkisiz/Süresi dolmuş) hatası gelirse
        if (error.status === 401) {
          // 1. LocalStorage'daki süresi dolmuş token'ı temizle
          this.authService.logout();
          
          // 2. Kullanıcıyı login sayfasına yönlendir
          this.router.navigate(['/login']);
        }

        // Hatanın uygulamanın geri kalanına da iletilmesini sağlarız
        const errorMsg = (error.error && error.error.message) || error.statusText;
        return throwError(errorMsg);
      })
    );
  }
}
